module.exports = __webpack_public_path__ + "fonts/la-brands-400.54b0b4e.woff2";